module.exports = __webpack_public_path__ + "components/rewards/dogtag/static/logo-3d4f45ae52621e141632fb32c7114166.jpg";